export const achievements = [
  {
    id: 1,
    name: 'First Book!',
    locale: 'firstbook',
    description: 'Complete your first book.',
    category: 'book_completion',
    level: 1,
    threshold: 1,
    displayNumber: 1,
  },
  {
    id: 2,
    name: 'Bookworm II',
    locale: 'booksII',
    description: 'Complete 3 books.',
    category: 'book_completion',
    level: 2,
    threshold: 3,
    displayNumber: 3,
  },
  {
    id: 3,
    name: 'Bookworm III',
    locale: 'booksIII',
    description: 'Complete 6 books.',
    category: 'book_completion',
    level: 3,
    threshold: 6,
    displayNumber: 6,
  },
  {
    id: 4,
    name: 'Bookworm IV',
    locale: 'booksIV',
    description: 'Complete 12 books.',
    category: 'book_completion',
    level: 4,
    threshold: 12,
    displayNumber: 12,
  },
  {
    id: 5,
    name: 'Streak I',
    locale: 'streakI',
    description: 'Read for 7 consecutive days.',
    category: 'reading_streak',
    level: 1,
    threshold: 7,
    displayNumber: 7,
  },
  {
    id: 6,
    name: 'Streak II',
    locale: 'streakII',
    description: 'Read for 14 consecutive days.',
    category: 'reading_streak',
    level: 2,
    threshold: 14,
    displayNumber: 14,
  },
  {
    id: 7,
    name: 'Streak III',
    locale: 'streakIII',
    description: 'Read for 30 consecutive days.',
    category: 'reading_streak',
    level: 3,
    threshold: 30,
    displayNumber: 30,
  },
  {
    id: 8,
    name: 'Streak IV',
    locale: 'streakIV',
    description: 'Read for 60 consecutive days.',
    category: 'reading_streak',
    level: 4,
    threshold: 60,
    displayNumber: 60,
  },
  {
    id: 9,
    name: 'Marathon reader I',
    locale: 'readerI',
    description: 'Read for 30 minutes in a single day.',
    category: 'daily_reading',
    level: 1,
    threshold: 30 * 60,
    displayNumber: '½',
  },
  {
    id: 10,
    name: 'Marathon reader II',
    locale: 'readerII',
    description: 'Read for 1 hour in a single day.',
    category: 'daily_reading',
    level: 2,
    threshold: 1 * 60 * 60,
    displayNumber: 1,
  },
  {
    id: 11,
    name: 'Marathon reader III',
    locale: 'readerIII',
    description: 'Read for 2 hours in a single day.',
    category: 'daily_reading',
    level: 3,
    threshold: 2 * 60 * 60,
    displayNumber: 2,
  },
  {
    id: 12,
    name: 'Marathon reader IV',
    locale: 'readerIV',
    description: 'Read for 3 hours in a single day.',
    category: 'daily_reading',
    level: 4,
    threshold: 3 * 60 * 60,
    displayNumber: 3,
  },
  {
    id: 13,
    name: 'Page turner I',
    locale: 'pagesI',
    description: 'Read 100 pages.',
    category: 'pages_read',
    level: 1,
    threshold: 100,
    displayNumber: 100,
  },
  {
    id: 14,
    name: 'Page turner II',
    locale: 'pagesII',
    description: 'Read 1000 pages.',
    category: 'pages_read',
    level: 2,
    threshold: 1000,
    displayNumber: 1000,
  },
  {
    id: 15,
    name: 'Page turner III',
    locale: 'pagesIII',
    description: 'Read 2500 pages.',
    category: 'pages_read',
    level: 3,
    threshold: 2500,
    displayNumber: 2500,
  },
  {
    id: 16,
    name: 'Page turner IV',
    locale: 'pagesIV',
    description: 'Read 5000 pages.',
    category: 'pages_read',
    level: 4,
    threshold: 5000,
    displayNumber: 5000,
  },
  {
    id: 17,
    name: 'Time well spent I',
    locale: 'timeI',
    description: 'Read 1 hour.',
    category: 'time_read',
    level: 1,
    threshold: 60 * 60,
    displayNumber: 1,
  },
  {
    id: 18,
    name: 'Time well spent II',
    locale: 'timeII',
    description: 'Read 10 hours.',
    category: 'time_read',
    level: 2,
    threshold: 10 * 60 * 60,
    displayNumber: 10,
  },
  {
    id: 19,
    name: 'Time well spent III',
    locale: 'timeIII',
    description: 'Read 50 hours.',
    category: 'time_read',
    level: 3,
    threshold: 50 * 60 * 60,
    displayNumber: 50,
  },
  {
    id: 20,
    name: 'Time well spent IV',
    locale: 'timeIV',
    description: 'Read 100 hours.',
    category: 'time_read',
    level: 4,
    threshold: 100 * 60 * 60,
    displayNumber: 100,
  },
  {
    id: 21,
    name: 'First session!',
    locale: 'sessionsI',
    description: 'Complete your first session.',
    category: 'sessions',
    level: 1,
    threshold: 1,
    displayNumber: 1,
  },
  {
    id: 22,
    name: 'Time well spent II',
    locale: 'sessionsII',
    description: 'Complete 15 sessions.',
    category: 'sessions',
    level: 2,
    threshold: 15,
    displayNumber: 15,
  },
  {
    id: 23,
    name: 'Time well spent III',
    locale: 'sessionsIII',
    description: 'Complete 75 sessions.',
    category: 'sessions',
    level: 3,
    threshold: 75,
    displayNumber: 75,
  },
  {
    id: 24,
    name: 'Time well spent IV',
    locale: 'sessionsIV',
    description: 'Complete 150 sessions.',
    category: 'sessions',
    level: 4,
    threshold: 150,
    displayNumber: 150,
  },
];
